import React from 'react';
import styled from 'styled-components';

import Image4 from '../../../../containers/assets/onboarding-gameoverview-image4.png';

const Wrapper = styled.div`
  background: #f5f6f7;
  padding: 40px;
  flex: 1;
`;

const Text1 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
`;

const Text2 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 24px;
`;

const Text3 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);
  margin-top: 12px;

  b {
    font-weight: 500;
    color: #ed716d;

    &.black-note {
      color: rgba(0, 27, 59, 0.94);
    }
  }
`;

const Image = styled.div`
  display: flex;
  margin-top: 12px;
`;

const GameOverviewStep4 = () => (
  <Wrapper>
    <Text1>Game Overview</Text1>
    <Text2>The Roles</Text2>
    <Text3>
      Your students will be assigned <b>one of the 5 roles</b> that <b>alternate</b> each round:
      CEO, Head of Product, Head of Marketing, Head of Operations, Head of Finance.
    </Text3>
    <Image>
      <img src={Image4} alt="" />
    </Image>
    <Text3>
      <b className="black-note">Note:</b> 1 student can play multiple roles (i.e. the CEO) and multiple students can play
      the same role. Therefore, you can have from 1 to 6 students on a team. <b>We highly recommend 4-6.</b>
    </Text3>
  </Wrapper>
);

export default GameOverviewStep4;



// WEBPACK FOOTER //
// ./src/instructor/components/onboarding/game-overview/step4.js